import React, { ReactElement } from 'react';

import { TResponsiveRenderProperties } from './responsive-render.types';
import { StyledDiv } from './responsive-render.styled';

export function ResponsiveRender({
    children,
    showOnBreakpoints,
}: TResponsiveRenderProperties): ReactElement {
    return (
        <StyledDiv showOnBreakpoints={showOnBreakpoints}>{children}</StyledDiv>
    );
}
